exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal-body[data-v-cbd01334] {\n    min-height: 500px;\n}\n.cropper__controls[data-v-cbd01334] {\n    left: 0;\n    bottom: 10px;\n}\n", ""]);

// exports
